import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "MANAGE_FORMS/MANAGE_FEDERAL_FORM";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPaginationState: (state, action) => {
            state.paginationState =  {...state.paginationState,...action.payload}
        },
        setPaginationState94x: (state, action) => {
            state.paginationState94x = { ...state.paginationState94x, ...action.payload }
        },
        setSelectedFederalForms: (state, action) => {
            state.selectedFederalForms = action.payload
        },
        toggle: (state, action) => {
            state.accordionOpen = action.payload
        },
        setSendPayerCopyEmailModal: (state, action) => {
            state.sendPayerCopyByEmailModal = action.payload;
        },
        setDownloadMultiplePDFModal: (state, action) => {
            state.downloadMultiplePDFModal = action.payload;
        },
        setDownloadSingleRowPDFModal: (state, action) => {
            state.downloadSingleRowPDFModal = action.payload;
        },
        setDownloadPDFsForSelectedPayerModal: (state, action) => {
            state.downloadPDFsForSelectedPayerModal = action.payload;
        },
        setDownloadPDFsByReferenceModal: (state, action) => {
            state.downloadPDFsByReferenceModal = action.payload;
        },
        setEDeliveryModalOpen: (state, action) => {
            state.eDeliveryModal = action.payload;
        },
        setSendPdfToPortalConfirmationModal: (state, action) => {
            state.sendPdfToPortalConfirmationModal = action.payload;
        },
        setSendPdfToPortalCreditCardModal: (state, action) => {
            state.sendPdfToPortalCreditCardModal = action.payload;
        },
        setExportToExcelModal: (state, action) => {
            state.exportToExcelModal = action.payload;
        },
        setExportToExcelForSelectedPayersModal: (state, action) => {
            state.exportToExcelForSelectedPayersModal = action.payload;
        },
        setExportToExcelForAllPayers: (state, action) => {
            state.exportToExcelForAllPayers = action.payload;
        },
        setUspsMailToRecipientsModal: (state, action) => {
            state.uspsMailToRecipientsModal = action.payload;
        },
        setUspsMailToRecipientsCreditCardModal: (state, action) => {
            state.uspsMailToRecipientsCreditCardModal = action.payload;
        },
        setBlockSubmissionModal: (state, action) => {
            state.blockSubmissionModal = action.payload;
        },
        setEmailRecipientCopyModal: (state, action) => {
            state.emailRecipientCopyModal = action.payload;
        },
        setSelectedFederalStates: (state, action) => {
            const { name, value } = action.payload
            state.federalStates[name] = value;
        },
        setFederalGridForms: (state, action) => {
            state.federalGridForms = action.payload;
        },
        setStateFilingCheckBox: (state, action) => {
            const { checked, index, checkBoxProperty } = action.payload;
            state.federalGridForms[index].IsState = checked;
            state.federalGridForms[index][checkBoxProperty] = checked ? "true" : "false";

            const formIndex = state.selectedFederalForms.findIndex((f) => f?.FormId == state.federalGridForms[index]?.FormId);

            if (formIndex >= 0) {
                state.selectedFederalForms[formIndex] = state.federalGridForms[index];
            }
        },
        setStateFilingSelectAllCheckbox: (state, action) => {
            const { name, checked } = action.payload;
            state.federalGridForms.map(form => { return form[name] = checked })
        },
        setFederal94XGridForms: (state, action) => {
            state.federal94XGridForms = action.payload;
        },
        setFederal94xTaxYear: (state, action) => {
            state.federal94xTaxYear = action.payload;
        },
        setSelectedFederal91xForms: (state, action) => {
            state.selectedFederal91xForms = action.payload;
        },
        setExportToExcelSelectedForm: (state, action) => {
            const { name, value } = action.payload
            state.exportToExcelStates[name] = value;
        },
        setSelectedPayers: (state, action) => {
            state.selectedPayers = action.payload
        },
        setDownloadPdfSelectedSelectedStates: (state, action) => {
            const { name, value } = action.payload
            state.downloadPdfStates[name] = value;
        },
        setDownloadPdfType: (state, action) => {
            state.downloadPdfType = action.payload
        },
        setSelectMultiplePayers: (state, action) => {
            state.multipleSelectedPayer = action.payload
        },
        setReferenceNumber: (state, action) => {
            state.referenceNumber = action.payload
        },
        setDownload94xMultiplePdfModal: (state, action) => {
            state.download94xMultiplePdfModal = action.payload
        },
        setBlockFederalFormModal: (state, action) => {
            state.blockFederalFormModal = action.payload
        },
        setFederalFormData: (state, action) => {
            state.federalFormData = action.payload
        },
        setChangeScheduleDate: (state, action) => {
            state.changeScheduleDateForAllVendor = action.payload;
        },
        setBlockSubmissionSelectedReference: (state, action) => {
            state.blockSubmissionSelectedReference = action.payload;
        },
        setStateFilingModal: (state, action) => {
            state.stateFilingModal = action.payload;
        },
        setSendPayerCopyByEmail94xModal: (state, action) => {
            state.sendPayerCopyByEmail94xModal = action.payload
        },
        setBulkStateFilingModal: (state, action) => {
            state.bulkStateFilingModal = action.payload;
        },
        setStateForms : (state, action)=>{
            state.stateForms = action.payload
        },
        setEDeliveryRequestedForms: (state, action) =>{
            state.eDeliveryRequestedForms = { ...state.eDeliveryRequestedForms, ...action.payload };
        },
        setOpenEDeliveryInfoModal: (state, action) =>{
            state.openEDeliveryInfoModal = action.payload;
        },
        setDownloadPdfCheckboxStates: (state, action)=>{
            state.downloadPdfCheckboxStates = { ...state.downloadPdfCheckboxStates, ...action.payload }
        },
        setReloadGridData: (state, action) => {
            state.reloadGridData = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        selectedFederalForms: [],
        federalGridForms: [],
        federal94XGridForms: [],
        federal94xTaxYear: [],
        selectedFederal91xForms: [],
        accordionOpen: true,
        selectedPayers: [],
        downloadPdfType: "",
        multipleSelectedPayer: [],
        federalFormData: {},
        stateForms:[],

        referenceNumber: [],

        federalStates: {
            FederalPayer: { value: "", label: "" },
            FederalTaxYear: { value: "", label: "" },
            FederalPayer2: { value: "", label: "" },
            FederalTaxYear2: { value: "", label: "" }
        },

        exportToExcelStates: {
            Payer: { value: "", label: "" },
            TaxYear: { value: "", label: "" },
            Form: { value: "", label: "" },
        },

        downloadPdfStates: {
            Forms: { value: "", label: "" },
            Reference: { value: "", label: "" },
        },

        downloadPdfCheckboxStates: {
            mergeCopies: false
        },

        blockSubmissionSelectedReference: { label: "", value: "" },

        paginationState: {
            PageNumber: 1,
            PageSize: 5,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            Total: 0,
            Page: 1
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        paginationState94x: {
            PageNumber: 1,
            PageSize: 5,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            Total: 10,
            Page: 1
        },

        //modals
        emailRecipientCopyModal: false,
        blockSubmissionModal: false,
        sendPayerCopyByEmailModal: false,
        downloadMultiplePDFModal: false,
        downloadPDFsForSelectedPayerModal: false,
        downloadSingleRowPDFModal: false,
        downloadPDFsByReferenceModal: false,
        eDeliveryModal: false,
        sendPdfToPortalConfirmationModal: false,
        sendPdfToPortalCreditCardModal: false,
        exportToExcelModal: false,
        exportToExcelForSelectedPayersModal: false,
        exportToExcelForAllPayers: false,
        uspsMailToRecipientsModal: false,
        uspsMailToRecipientsCreditCardModal: false,
        download94xMultiplePdfModal: false,
        blockFederalFormModal: false,
        changeScheduleDate: false,
        stateFilingModal: false,
        sendPayerCopyByEmail94xModal: false,
        bulkStateFilingModal: false,

        eDeliveryRequestedForms: {
            alreadyRequestedForms: [],
            newlyRequestedForms: []
        },

        openEDeliveryInfoModal: false,
        reloadGridData: false,
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
    }
})

export const { setPaginationState, setSelectedFederalForms, toggle, setSendPayerCopyEmailModal, setDownloadMultiplePDFModal, setDownloadPDFsForSelectedPayerModal, setDownloadPDFsByReferenceModal, setBlockSubmissionModal, setEDeliveryModalOpen, setSendPdfToPortalConfirmationModal, setSendPdfToPortalCreditCardModal, setExportToExcelModal, setExportToExcelForSelectedPayersModal, setExportToExcelForAllPayers, setUspsMailToRecipientsModal, setUspsMailToRecipientsCreditCardModal, setEmailRecipientCopyModal, setSelectedFederalStates, setFederalGridForms, setStateFilingCheckBox, setStateFilingSelectAllCheckbox, setFederal94XGridForms, setFederal94xTaxYear, setSelectedFederal91xForms, setExportToExcelSelectedForm, setSelectedPayers, setDownloadPdfSelectedSelectedStates, setDownloadPdfType, setSelectMultiplePayers, setReferenceNumber, setDownload94xMultiplePdfModal, setBlockFederalFormModal, setFederalFormData, setChangeScheduleDate, setBlockSubmissionSelectedReference, setStateFilingModal, setSendPayerCopyByEmail94xModal, setPaginationState94x, setBulkStateFilingModal, setStateForms, setEDeliveryRequestedForms, setOpenEDeliveryInfoModal, setDownloadSingleRowPDFModal, setDownloadPdfCheckboxStates, setReloadGridData, setLoadingState, setPayerDropdownPagination } = actions; 
